export const themes = {
  dark: {
    f10WrapperBg: '#070707',
    f10TopBg: '#070707',
    f10TopTextColor: '#d7d7df',
    f10IshiddenNavBg: '#fff',
    f10IshiddenNavColor: '#1890ff',
    antCardBg: '#121318',
    antCardHeadBg: '#181c26',
    antCardHeadColor: '#ffffff',
    antColTitleBg: '#252a34',
    antColTitleTextColor: '#aaaaaa',
    antColBorderColor: '#252a34',
    antCardTextColor: '#d7d7df',
    antTabsTabBg: '#1d2230',
    antTabsTabText: '#7D7D7D',
    antTabsTabTextActive: '#ffffff',
    antRadioWrapperColor: '#d7d7df',
    anchorLinkColor: '#aaa',
    anchorLinkActiveColor: '#d7d7df'
  },
  light: {
    primaryColor: '#f8f9fb',
    f10TopBg: '#f8f9fb',
    f10TopTextColor: '#4d4d4d',
    f10IshiddenNavBg: 'linear-gradient(186deg, #569bf4 0%, #2775e9 100%)',
    f10IshiddenNavColor: '#fff',
    antCardBg: '#ffffff',
    antCardHeadBg: '#ECEEF3',
    antCardHeadColor: '#4D4D4D',
    antColTitleBg: '#F0F3FB',
    antColTitleTextColor: '#4D4D4D',
    antColBorderColor: '#EBEBEB',
    antCardTextColor: '#1D1D1D',
    antTabsTabBg: '#F2F5FA',
    antTabsTabText: '#7D7D7D',
    antTabsTabTextActive: '#ffffff',
    antRadioWrapperColor: '#1D1D1D',
    anchorLinkColor: '#7d7d7d',
    anchorLinkActiveColor: '#4d4d4d'
  }
}
